var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",staticStyle:{"min-width":"50%"}},[_c('v-select',_vm._b({attrs:{"value":_vm.value,"label":"label","placeholder":"Select a font-family","options":_vm.fontsOptions},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var label = ref.label;
var value = ref.value;
return [_c('span',{style:({ fontFamily: value })},[_vm._v(_vm._s(label)+" ")])]}}])},'v-select',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }